import { MapTo } from '@adobe/aem-react-editable-components';
import ConfirmationAdModule, { ConfirmationAdModuleEditConfig } from './ConfirmationAdModule';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/confirmation-ad-module',
)(ConfirmationAdModule, ConfirmationAdModuleEditConfig);